module.exports = __webpack_public_path__ + "static/energy_private_13-81bb8fedc6a0c7612ed5982b19f45ebc.jpg";